// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { Checkmark } from '../../assets/svg/common';
import theme from '../../styled-components/dark';
import type { OutcomeStatus } from '../../types/history';
import HistoryItemOutcomeContentFactoryContainer from '../HistoryItemOutcomeContentFactory/HistoryItemOutcomeContentFactoryContainer';

const Wrapper = styled.div`
  padding-left: 0.33em;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
`;

const OutcomeWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const BankerWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 0.55em;
  margin-left: 0.46em;
  padding: 0 0.37em;

  background: ${theme.History.outcome.content.bankerBackgroundColor};
  color: ${theme.History.outcome.content.bankerColor};
  font-size: 0.73em;
  white-space: nowrap;
`;

const BankerCheckmark = styled(Checkmark)`
  width: 0.8em;
  margin-right: 0.25em;
  color: ${theme.History.outcome.content.checkmarkColor};
`;

type HistoryItemOutcomeCardContentProps = {
  className?: string;
  isBanker?: boolean;
  outcome: unknown;
  shouldDisplayFlag?: boolean;
  flagId?: string;
  shouldDisplayOutcomeContent?: boolean;
  status: OutcomeStatus;
  isMyMatch?: boolean;
  isSimpleBet?: boolean;
  isUserPrefsCompact?: boolean;
};

const HistoryItemOutcomeCardContent = ({
  className,
  isBanker,
  outcome,
  shouldDisplayFlag,
  flagId,
  shouldDisplayOutcomeContent,
  status,
  isSimpleBet,
  isUserPrefsCompact,
}: HistoryItemOutcomeCardContentProps) => {
  return (
    <Wrapper className={className}>
      <Row>
        <OutcomeWrapper>
          {shouldDisplayOutcomeContent ? (
            <HistoryItemOutcomeContentFactoryContainer
              outcome={outcome}
              flagId={flagId}
              shouldDisplayFlag={shouldDisplayFlag}
              outcomeStatus={status}
              isSimpleBet={isSimpleBet}
              isUserPrefsCompact={isUserPrefsCompact}
              noBreakLine
            />
          ) : null}
          {isBanker ? (
            <BankerWrapper>
              <BankerCheckmark />
              Base
            </BankerWrapper>
          ) : null}
        </OutcomeWrapper>
      </Row>
    </Wrapper>
  );
};

export default HistoryItemOutcomeCardContent;
